const assignmentStatusList = [
  {
    id: 10,
    name: 'Stand by'
  },
  {
    id: 15,
    name: 'Concurrent'
  },
  {
    id: 20,
    name: 'Placed'
  },
  {
    id: 25,
    name: 'Completed'
  }
];

export default assignmentStatusList;
